module.exports = __webpack_public_path__ + "img/enjoysolar_180.4e07b610.png";